import { render, staticRenderFns } from "./StudentSearch.vue?vue&type=template&id=f8457954&scoped=true"
import script from "./StudentSearch.vue?vue&type=script&lang=js"
export * from "./StudentSearch.vue?vue&type=script&lang=js"
import style0 from "./StudentSearch.vue?vue&type=style&index=0&id=f8457954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8457954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VTextField})
